// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2WyLt","legacyBtn":"MutateMid_legacyBtn__FogWJ"};